import { useEffect, useRef } from "react"

import { useEditor } from "@craftjs/core"

import { useAutoSave, useEditing } from "@/modules/cms/views/post/components/builder/context"

export default function useAutoSelectEditing() {
  const { value: editing } = useEditing()
  const { setBaseline } = useAutoSave()
  const { actions: { history: { ignore } }, query } = useEditor()
  const ignoreRef = useRef(ignore())
  const queryRef = useRef(query)

  ignoreRef.current = ignore()
  queryRef.current = query

  useEffect(() => {
    const { current: { deserialize } } = ignoreRef

    if (editing) {
      const { definition: { craft } } = editing
      deserialize(craft)
    } else {
      deserialize({})
    }

    setBaseline(queryRef.current.getSerializedNodes())
  }, [editing, setBaseline])
}
